export { default as AdPrice } from './AdPrice';



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/AdSummary/AdPrice/index.ts